import { mdiCamera, mdiCameraOutline } from '@mdi/js'
import Icon from '@mdi/react'
import type { IconProps } from '.'

const CameraIcon = (props: IconProps) => {
    const { filled, ...other } = props

    return (
        <Icon
            data-testid="IconButton__CameraButton"
            path={filled ? mdiCamera : mdiCameraOutline}
            size={1}
            {...other}
        />
    )
}

export default CameraIcon
export { CameraIcon }
